module.exports = __webpack_public_path__ + "static/scale-model-of-louisiana's-old-state-capitol-in-baton-rouge-louisiana-a68b91d204f144eea5a730cb4c46051c.png";